import { MEWS_COMMUNITY_WEIGHT, MewsCommunityWidget } from './components';

export const useDashboardWidgets = () => {
    const widgets = [
        {
            component: <MewsCommunityWidget />,
            weight: MEWS_COMMUNITY_WEIGHT,
        },
    ];

    return widgets;
};
